import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type PortalProfile = {
  user_id: string;
  email: string;
  full_name: string | null;
  role_at_partner: string | null;
  website: string | null;
  integrates_with: string[];
  onboarded_at: string | null;
};

// GET /api/portal/profile — partner-facing profile composite (joins
// profiles + partner_users + partners.website).
export function usePortalProfile() {
  return useQuery<PortalProfile, ApiClientError>({
    queryKey: queryKeys.portal.profile(),
    queryFn: () => apiFetch<PortalProfile>("/portal/profile"),
  });
}
